import { createSlice } from '@reduxjs/toolkit';
const initialState = [];
const selectedKeys = createSlice({
  name: 'selectedKeys',
  initialState,
  reducers: {
    handleSelectedKeys: (state, { payload }) => {
      return payload;
    },
    resetSelectedKeys: () => initialState
  }
});
export const { handleSelectedKeys, resetSelectedKeys } = selectedKeys.actions;
export default selectedKeys;
